function debounce(func, wait, immediate = false) {
  let timeout;

  return function () {
    let ctx = this;
    let args = arguments;

    clearTimeout(timeout);

    timeout = setTimeout(function () {
      timeout = null;

      if (!immediate) {
        func.apply(ctx, args);
      }
    }, wait);

    if (immediate && !timeout) {
      func.apply(ctx, args);
    }
  };
}

function downloadFile(name, base64) {
  let a = document.createElement("a");
  a.href = "data: ;base64," + base64;
  a.download = name;

  a.click();
  a.remove();
}

function concatArrayInArrayWithUniqueItems (firstArr = [], secondArr = [], key) {
  for (let i = firstArr.length - 1; i >= 0;  --i) {
    secondArr = secondArr.filter(item => item[key] !== firstArr[i][key])
  }

  return [...firstArr, ...secondArr]
}

export { debounce, downloadFile, concatArrayInArrayWithUniqueItems };

